<template>
  <aside class="widget" v-if="$route.name !== 'Recognition' && $route.name !== 'Recognition'">
    <h4>Equity Manager</h4>
    <router-link to="/report-equity"><h5><i class="fas fa-quote-left fa-fw fa-sm"></i> Report: Employment Equity <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
  </aside>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EquityLinks.vue